// src/components/Dashboard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import RoadmapCard from './RoadmapCard'; 
import './Dashboard.css'; 

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [savedRoadmaps, setSavedRoadmaps] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login'); 
        return;
      }

      try {
        const res = await axios.get('http://localhost:5000/api/users/me', {
          headers: { Authorization: `Bearer ${token}` }
        });

        setUser({
          ...res.data.user,
          topSkills: res.data.user.topSkills || []
        });
        setSavedRoadmaps(res.data.roadmaps || []);
      } catch (err) {
        console.error(err);
        localStorage.removeItem('token');
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  if (loading) return <p className="loading-text">Loading your dashboard...</p>;
  if (!user) return null;

  return (
    <div className="dashboard-page section-padding">
      <div className="main-content">
        <header className="dashboard-header">
          <h1 className="dashboard-title">Welcome back, {user.name}!</h1>
          <p className="dashboard-subtext">Your personalized journey continues here.</p>
        </header>

        <section className="dashboard-stats">
          <div className="stat-card">
            <h3>Overall Progress</h3>
            <p className="stat-value">{user.progress ?? 0}%</p>
          </div>
          <div className="stat-card">
            <h3>Commitment Streak</h3>
            <p className="stat-value">{user.currentStreak ?? 0} days</p>
          </div>
          <div className="stat-card">
            <h3>Roadmap Completion</h3>
            <p className="stat-value">{user.completionRate ?? 0}%</p>
          </div>
        </section>

        <section className="dashboard-content dashboard-skills-section">
          <h2>Key Skills & Proficiency</h2>
          {user.topSkills.length > 0 ? (
            <div className="skill-tags">
              {user.topSkills.map(skill => (
                <span key={skill} className="skill-tag">{skill}</span>
              ))}
            </div>
          ) : (
            <p className="placeholder-text">You haven’t added any skills yet.</p>
          )}
        </section>

        <section className="dashboard-content">
          <h2>Your Saved Roadmaps</h2>
          {savedRoadmaps.length > 0 ? (
            <div className="roadmap-list">
              {savedRoadmaps.map(roadmap => (
                <RoadmapCard 
                  key={roadmap.id}
                  title={roadmap.title}
                  slug={roadmap.slug}
                  progress={roadmap.progress}
                  stepsCompleted={roadmap.stepsCompleted}
                  totalSteps={roadmap.totalSteps}
                  projectTitle={roadmap.projectTitle} 
                  projectLink={roadmap.projectLink}
                />
              ))}
            </div>
          ) : (
            <p className="placeholder-text">You haven’t saved any roadmaps yet.</p>
          )}
        </section>
      </div>
    </div>
  );
};

export default Dashboard;


